<template>
    <div>
        
        <v-container class="py-16">
            <v-img class="mb-10" src="../assets/img/banner_inv.jpg"></v-img> 
            <h2>Línea de Investigación</h2>
            <!--<h4 class="mt-10">El problema</h4>
            <p>La insuficiencia renal es un problema mundial que se incrementa a pasos agigantados y Chile no está extenso. Las últimas décadas ha habido un aumento explosivo de los pacientes cuyo problema renal deriva en someterse a diálisis de manera permanente. Para un problema renal la mejor solución es el trasplante de órganos. Es por ello que a los pacientes más graves y cuyas condiciones lo permitan, se les asigna a una lista de espera de órganos. En Chile el 10% de los pacientes en diálisis está en lista de espera, mientras que en el mundo este porcentaje llega a 30%. Lamentablemente el trasplante no alcanza para todos, por lo que la lista de espera aumenta año a año llegando a cerca de los 2000 pacientes. Los dos principales problemas en la tasa de donantes son la baja pesquisa y la negativa familiar.</p>
            <h4 class="mt-10">La solución</h4>
            <p>La solución desarrollada consiste en un sistema automático de aviso de PD de órganos desde el personal profesional del Servicio de Urgencia (SU) y de la Unidad de Cuidados Intensivos (UCI) hacia la Unidad o Coordinadora Local de Procuramiento (CLP). El personal de SU y UCI llena en una aplicación para Smartphone 4 variables clínicas del paciente: <b>causa de ingreso, Glasgow Coma Scale (GCS), edad y sexo,</b> y presionar el botón de “Alertar”, donde la aplicación realiza una llamada telefónica al móvil de la CLP y genera una notificación a la app donde la CLP puede revisar los datos enviados del paciente y devolver el llamado al emisor, permitiendo avisar rápida y fácilmente.</p>
            -->
           
            <!--articulos-->
            <v-row id="articulos" class="mt-3 no-gutters justify-space-between align-center">
                <p class=" cuerpo-texto">El equipo de Kefuri lleva años investigando el sistema de donación en Chile, con tal de poder entender el problema que afecta la baja tasa de donación del país. Nuestros hallazgos han sido presentados en diversos congresos, procurando hacer notar el problema del sistema y generar un aporte al área en el país.</p>
                <v-col class="pl-md-5 pt-16 mt-5">
                    <h3>Artículos y publicaciones</h3>

                    <v-list>
                        <v-list-item-content> 
                            <v-list-item-title class="mb-2"> <b> “Kefuri: A novel technological tool for increasing organ donation in Chile” </b> </v-list-item-title>
                            <v-list-item-subtitle>-F. González Cohens, F. Vera Cid, F. González Fuenzalida, y J. D. Velásquez Silva</v-list-item-subtitle>
                            <p> International Conference on Web Intelligence, Aceptado, 2020.</p>
                        </v-list-item-content>

                        <v-list-item-content> 
                            <v-list-item-title class="mb-2"> <b> “Análisis crítico de la baja tasa de donación de órganos en Chile” </b> </v-list-item-title>
                            <v-list-item-subtitle>-F. González Cohens, F. Vera Cid, R. Alcayaga Droguett, y F. González Fuenzalida </v-list-item-subtitle>
                            <p> Revista Med Chile, vol. 148, no 2, pp. 267–276, abr. 2020.<v-btn color="primary" text target="_blank" href="https://scielo.conicyt.cl/scielo.php?script=sci_arttext&pid=S0034-98872020000200242">Ver publicación</v-btn></p>
                        </v-list-item-content>

                        <v-list-item-content> 
                            <v-list-item-title class="mb-2"> <b> “El sinsabor que deja el mejor año en la donación de órganos para trasplante en Chile” </b> </v-list-item-title>
                            <v-list-item-subtitle>-F. González Fuenzalida y F. González Cohens </v-list-item-subtitle>
                            <p> Rev. Med Chile, vol. 146, no 5, pp. 547–554, 2018. <v-btn color="primary" text target="_blank" href="https://scielo.conicyt.cl/scielo.php?script=sci_arttext&pid=S0034-98872018000500547">Ver publicación</v-btn></p>
                        </v-list-item-content>

                        <v-list-item-content> 
                            <v-list-item-title class="mb-2"> <b> “Análisis del Perfil de Enfermera Coordinadora de Procuramiento de Órganos en Chile” </b> </v-list-item-title>
                            <v-list-item-subtitle>-R. Alcayaga Droguett, J. Stiepovich Bertoni, y F. González Fuenzalida</v-list-item-subtitle>
                            <p> Revista. Soc. Esp. Enferm. Nefrológica, vol. 22 (4), pp. 428–434, 2019, doi: 10.4321/S2254-28842019000400010.<v-btn color="primary" text target="_blank" href="https://scielo.conicyt.cl/scielo.php?script=sci_arttext&pid=S0034-98872018000500547">Ver publicación</v-btn></p>
                        </v-list-item-content>

                        <v-list-item-content>
                            <v-list-item-title class="mb-2"> <b> “Diseño de una propuesta de protocolo de estandarización y gestión de calidad para el proceso de procuramiento de órganos”</b> </v-list-item-title>
                            <v-list-item-subtitle>-R. Alcayaga Droguett, J. Stiepovich Bertoni, F. González Fuenzalida </v-list-item-subtitle>
                            <p>Revista. Médica Chile, vol. 147, n o 3, pp. 296–304, 2019, doi: 10.4067/S0034-98872019000300296. <v-btn color="primary" text target="_blank" href="https://scielo.conicyt.cl/scielo.php?script=sci_arttext&pid=S0034-98872019000300296">Ver publicación</v-btn></p>
                            
                        </v-list-item-content>

                        <h3 class="mt-6">Tesis de pre y post grado</h3>

                        <v-list-item-content>
                            <v-list-item-title class="mb-2"> <b>“Procuramiento de órganos en Chile, un análisis crítico desde un modelo de gestión de calidad” </b></v-list-item-title>
                            <v-list-item-subtitle>-R. Alcayaga </v-list-item-subtitle>  
                            <p> Tesis de Doctorado, Universidad de Concepción, Concepción, Chile, 2019. </p>
                        </v-list-item-content>

                        <v-list-item-content>
                            <v-list-item-title class="mb-2"> <b>“Capacidades de la Coordinadora Nacional de Procuramiento y Trasplante para garantizar el acceso a un órgano” </b></v-list-item-title>
                            <v-list-item-subtitle>-M. E. Canales Mena </v-list-item-subtitle>  
                            <p> Tesis de Magíster, Universidad de Chile, 2018. <v-btn color="primary" text target="_blank" href="http://repositorio.uchile.cl/handle/2250/152129">Ver más</v-btn> </p>
                        </v-list-item-content>

                        <v-list-item-content>
                            <v-list-item-title class="mb-2"> <b>“Propuesta de rediseño organizacional para las unidades encargadas de la detección de posibles donantes en hospitales” </b></v-list-item-title>
                            <v-list-item-subtitle>-N. Adaros </v-list-item-subtitle>  
                            <p> Memoria de Título, 2017. <v-btn color="primary" text target="_blank" href="http://repositorio.uchile.cl/handle/2250/148506">Ver más</v-btn> </p>
                        </v-list-item-content>

                        <v-list-item-content>
                            <v-list-item-title class="mb-2"> <b>“Propuesta de indicadores para la creación de un sistema de control de gestión para las unidades de procuramiento de órganos en Chile” </b></v-list-item-title>
                            <v-list-item-subtitle>-B. Wilhelm Núñez </v-list-item-subtitle>  
                            <p> Memoria de Título, Universidad de Chile, 2018. <v-btn color="primary" text target="_blank" href="http://repositorio.uchile.cl/handle/2250/170051">Ver más</v-btn>  </p>
                        </v-list-item-content>

        
                    </v-list>
                </v-col>
            </v-row>
            <!--/articulos-->

             <!--Congresos y eventos-->
            <v-row id="congreso" class="mt-10 no-gutters justify-space-between align-center">
                
                <v-col cols="12" sm="4">
                    <img class="img-fluid" src="../assets/img/conferencias.png">
                </v-col>
                <v-col md="7" class="pl-md-5 pt-5">
                    <h3>Presentaciones en congresos</h3>

                    <v-expansion-panels>
                        <!--/panel 1-->
                        <v-expansion-panel>
                            <v-expansion-panel-header>
                                XX Congreso Latinoamericano y del Carible de Trasplante
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-list>
                                    <v-list-item>
                                        <v-list-item-content>
                                       <b> “Discordancia entre el perfil declarado y el observado en coordinadores de procuramiento de órganos en Chile” </b> R. Alcayaga Droguett, F. González Cohens, F. Vera Cid, y F. González Fuenzalida, Chile, México, 2019, p. 71.
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                        <b>“Coordinadoras part-time compartidas con trasplante parecen ser quienes más procuran”</b> F. González Cohens, F. Vera Cid, R. Alcayaga Droguett, y F. González Fuenzalida, Chile, México, 2019, p. 73.
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                        <b>“El ineficiente uso de recursos en campañas de donación”</b> F. González Cohens, F. Vera Cid, R. Alcayaga Droguett, y F. González Fuenzalida, presentado en Congreso Latinoamericano y del Caribe de Trasplante, México, 2019.
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                        <b>“Discordancia entre el perfil declarado y el observado en coordinadores de procuramiento de órganos en Chile”</b> R. Alcayaga Droguett, F. González Cohens, F. Vera Cid, y F. González Fuenzalida, Chile, México, 2019, p. 71.
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                        <v-btn href="http://congreso2019.sociedaddetrasplante.cl/assets/libro-resumen-congreso-trasplante-2019.pdf" target="_blank" rel="noopener" color="primary">Ver documento</v-btn>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                        <!--/panel 1-->
                        <!--Panel 2-->
                        <v-expansion-panel>
                            <v-expansion-panel-header>
                                XXXVI Congreso de Nefrología, Hipertensión y Trasplante Renal
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-list>
                                    <v-list-item>
                                        <v-list-item-content>
                                        <b>“Ni las campañas a favor ni en contra de la donación de órganos afectan las tasas de donación”</b> F. González Cohens, F. Vera Cid, R. Alcayaga Droguett, y F. González Fuenzalida, La Serena,Chile, oct. 2019, p. 13.
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                        <b>“La inequidad del sistema de procuramiento y trasplante puede explicar, al menos en parte, las bajas tasas de donación en Chile”</b> F. González Cohens, F. Vera Cid, R. Alcayaga Droguett, y F. González Fuenzalida, La Serena,Chile, oct. 2019, p. 138.
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                        <v-btn href="http://www.nefro.cl/v2/docs/libro_congreso_nefrologia_2019.pdf" target="_blank" rel="noopener" color="primary">Ver documento</v-btn>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                        <!--/panel 2-->
                        <!--panel 3-->
                        <v-expansion-panel>
                            <v-expansion-panel-header>
                                VII Congreso chileno de trasplante
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-list>
                                    <v-list-item>
                                        <v-list-item-content>
                                        <b>“El sorprendente desempeño de las CLP explican los resultados de donación en Chile. Análisis del período 2013-2018”</b> F. González Cohens, F. Vera Cid, R. Alcayaga Droguett, y F. González Fuenzalida, Chile, 2019, p. 74.
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                        <b>“Coordinadoras part-time compartidas con trasplante parecen ser quienes más procuran”</b> F. González Cohens, F. Vera Cid, R. Alcayaga Droguett, y F. González Fuenzalida, Chile, México, 2019, p. 73.
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                        <b>“Discordancia entre el perfil declarado y el observado en coordinadores de procuramiento de órganos en Chile”</b> R. Alcayaga Droguett, F. González Cohens, F. Vera Cid, y F. González Fuenzalida, Chile, México, 2019, p. 71.
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                        <v-btn href="http://congreso2019.sociedaddetrasplante.cl/assets/libro-resumen-congreso-trasplante-2019.pdf" target="_blank" rel="noopener" color="primary">Ver documento</v-btn>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                        <!--/panel 3-->
                        <!--panel 4-->
                        <v-expansion-panel>
                            <v-expansion-panel-header>
                                XXXV Congreso de Nefrología, Hipertensión y Trasplante Renal
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-list>
                                    <v-list-item>
                                        <v-list-item-content>
                                        <b>“Las unidades de procura de los hospitales públicos requieren de urgente reingeniería: El modelo actual definitivamente no sirve”</b>  F. González Cohens, F. Vera Cid, J. L. Rojas Barraza, y F. González Fuenzalida, Pucón, Chile, oct. 2018, pp. 92–93, Accedido: mar. 28, 2019.
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                        <b>“Las campañas de TV no mejoran la tasa de negativa familiar a la donación de órganos”</b> F. González Fuenzalida, F. González Cohens, F. Vera Cid, y J. L. Rojas Barraza, Pucón, Chile, oct. 2018, pp. 92–93.
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                        <b>“Si no dejáremos de detectar casi a todos los potenciales donantes, podríamos incluso alcanzar al líder en donación de órganos”</b> F. Vera Cid, F. González Cohens, J. L. Rojas Barraza, y F. González Fuenzalida, presentado en XXXV Congreso Chileno de Nefrología, Hipertensión y Trasplante Renal, Pucón, Chile, oct. 2018, pp. 92–93.
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                        <v-btn href="https://www.nefro.cl/v2/biblio/congresos/240.pdf" target="_blank" rel="noopener" color="primary">Ver documento</v-btn>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                        <!--/panel 4-->
                        <!--panel 5-->
                        <v-expansion-panel>
                            <v-expansion-panel-header>
                                VI Congreso chileno de trasplante
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-list>
                                    <v-list-item>
                                        <v-list-item-content>
                                        <b>“Estudio del proceso de pesquisa de posibles donantes de órganos en centros trasplantadores de la región metropolitana. Resultados preliminares.”</b> F. González et al., presentado en Congreso Sociedad Chilena de Trasplante, 2017.
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                        <v-btn href="https://www.nefro.cl/v2/biblio/congresos/240.pdf" target="_blank" rel="noopener" color="primary">Ver documento</v-btn>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                        <!--/panel 5-->
                    </v-expansion-panels>
                </v-col>
            </v-row>
            <!--/Congresos y eventos -->
        </v-container>
    </div> 
</template>

<script>
export default {
    name: 'Info',
    components: {

    }
}
</script>

<style scoped lang="sass">
a
    text-decoration: none
</style>